import { deleteAnnouncement, fetchAnnouncement, fetchNotification, postAnnouncemnt, setAnnounceKey, setDraftPage, setSchedulePage, storeAnnouncePage } from 'actions/announcement';
import { Input, Modal, Typography, Select, Button, Checkbox, TimePicker, DatePicker, Col, Row, Drawer } from 'antd'
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react'
import ReactQuill from 'react-quill';
import { connect } from 'react-redux';
import styled from 'styled-components'
import 'react-quill/dist/quill.snow.css';
import { CalendarOutlined, DeleteFilled, DeleteOutlined, FieldTimeOutlined, LockFilled, LockOutlined, PercentageOutlined, SearchOutlined, WarningTwoTone } from '@ant-design/icons';
import { notificationBadgeList } from 'actions/login';
import CreateAnnouncmentModal from './createAnnouncmentModal';
import Dragger from 'antd/lib/upload/Dragger';
import { message, Upload } from 'antd';
import file_image_1 from '../../../Assets/images/file_image_1.svg'
import ic_file_eadd from '../../../Assets/images/ic_file_eadd.svg'
import Xmark from '../../../Assets/common/Xmark.svg'
import downArrow from '../../../Assets/common/downArrow.svg'
import Notification from "services/Notification";
import AnimatedTextField from 'components/AnimatedTextField';
import { getAutocompleteSearchForNotification, getCourseDashboardData, getCoursesCategoriesForNotifications, getCoursesSubCategoriesForNotification } from 'actions/courseManagement';
import { fetchClassList } from 'actions/schedule';
import AnimatedDatePicker from 'components/AnimatedDatePicker';
import AnimatedTimePicker from 'components/AnimatedTimePicker';
import AnnouncementDeleteModal from './announcementDeleteModal';


const { Text } = Typography
const { Option } = Select

const calenderIcon = <CalendarOutlined style={{ color: "#1089FF" }} />
const timeIcon = <FieldTimeOutlined style={{ color: "#1089FF" }} />

const CreateFormAnnouncementInput = styled.div`
        width: 100%;
        height: 85%;
        padding: 10px;
        overflow-y: scroll;
`;

const CreateFormAnnouncementButton = styled.div`
        width:100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        padding:20px
`;

const EditFormScheduleButton = styled.div`
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding: 20px;
`;

const EditFormDraftButton = styled.div`
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding: 20px;
`;

const CreateAnnouncement = ({
    isModalVisible, setIsModalVisible, edit, postAnnouncemnt, editData, fetchAnnouncement, togglePageLoader, deleteAnnouncement, fetchNotification, notificationBadgeList, SetKey, standardList, courseDashboardData, getCourseDashboardData,getAutocompleteSearchForNotification,fetchClassList,
    setSort, sortFilter, searchFilter, announcement, setDraftPage, setSchedulePage, key, setAnnounceKey, storeKey, setIsSearch, storeAnnouncePage, setStdFilterValue, courseCategoryData, courseSubCategoriesData, autocompleteSearchData, classList,getCoursesSubCategoriesForNotification,getCoursesCategoriesForNotifications,
}) => {

    const [check, setCheck] = useState((edit === 'schedule' || edit === 'draft') && editData?.date && editData?.date !== "0000-00-00" ? true : false)
    const [announceButtonLoader, setAnnounceButtonLoader] = useState(false)
    const [draftButtonLoader, setDraftButtonLoader] = useState(false)
    const [scheduleLoader, setScheduleLoader] = useState(false)
    const [deleteButtonLoader, setDeleteButtonLoader] = useState(false)
    const [id, setId] = useState(null)
    const [deleteShow, setDeleteShow] = useState(false)

    const [title, setTitle] = useState('')
    const [description, setDescription] = useState('')
    const [descriptionTyped, setDescriptionTyped] = useState(false)
    const [target, setTarget] = useState('All')
    const [date, setDate] = useState((edit === 'schedule' || edit === 'draft') && editData?.date && editData?.date !== "0000-00-00" ? editData?.date : undefined)
    const [time, setTime] = useState((edit === 'schedule' || edit === 'draft') && editData?.time && editData?.time !== "00:00:00" && editData?.date !== "0000-00-00" ? editData?.time : undefined)
    const [type, setType] = useState('')
    const [studentsType, setStudentsType] = useState('allStudents')
    const [std, setStd] = useState([])
    const [classListShow, setClassListShow] = useState(true)
    const [descriptionLength, setDescriptionLength] = useState(null)
    const [file, setfile] = useState([])
    const [hideFile, setHideFile] = useState(true)
    const [fileVisible, setFileVisible] = useState(editData?.fileName)
    const [isDisable, setIsDisable] = useState(false)
    const [checkedItems, setCheckedItems] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState([]);
    const [selectedSubCategory, setSelectedSubCategory] = useState([]);
    const [selectedCourses, setSelectedCourses] = useState([]);
    const [selectedBatches, setSelectedBatches] = useState([]);
    const [updatedClassList, setUpdatedClassList] = useState([]);
    const [momentDate, setMomentDate] = useState(edit !== '' ? true : false);

    useEffect(() => {
        getCoursesCategoriesForNotifications()
        getCoursesSubCategoriesForNotification()
        getAutocompleteSearchForNotification(null, () => { })
        fetchClassList('', null)
        getCourseDashboardData(() => { })
    }, [])


    useEffect(() => {
        setUpdatedClassList(classList.map(({ section, std, ...rest }) => ({
            ...rest,
            name: `${std} - ${section}` // Rename 'section' to 'name'
        })))
    }, [])



    const options = [
        courseDashboardData?.overview?.some(item => item?.overviewType == "liveCourse") && { label: "Classroom courses", value: "course" },
        courseDashboardData?.overview?.some(item => item?.overviewType == "videoResource") && { label: "Video resources", value: "videoResource" },
        courseDashboardData?.overview?.some(item => item?.overviewType == "testSeries") && { label: "Online test series", value: "testSeries" },
        courseDashboardData?.overview?.some(item => item?.overviewType == "studyMaterial") && { label: "Study materials", value: "studyMaterial" },

    ].filter(Boolean);

    const handleChange = (checkedValues) => {
        setCheckedItems(checkedValues);
    };

    const handleChangeCategories = (value) => {
        const selectedCourse = courseCategoryData.find(course => course.id === value);
        if (selectedCourse) {
            const isAlreadySelected = selectedCategory.some(course => course.id === value);
            if (!isAlreadySelected) {
                setSelectedCategory(prevCourses => [...prevCourses, selectedCourse]);
            }
        }
    };
    const handleChangeSubCategories = (value) => {
        const selectedCourse = courseSubCategoriesData.find(course => course.id === value);
        if (selectedCourse) {
            const isAlreadySelected = selectedSubCategory.some(course => course.id === value);
            if (!isAlreadySelected) {
                setSelectedSubCategory(prevCourses => [...prevCourses, selectedCourse]);
            }
        }
    };
    const handleChangeCourses = (value) => {
        const selectedCourse = autocompleteSearchData.find(course => course.id === value);
        if (selectedCourse) {
            const isAlreadySelected = selectedCourses.some(course => course.id === value);
            if (!isAlreadySelected) {
                setSelectedCourses(prevCourses => [...prevCourses, selectedCourse]);
            }
        }
    };

    const handleChangeBatches = (value) => {
        const selectedCourse = updatedClassList.find(course => course.id === value);
        if (selectedCourse) {
            const isAlreadySelected = selectedBatches.some(course => course.id === value);
            if (!isAlreadySelected) {
                setSelectedBatches(prevCourses => [...prevCourses, selectedCourse]);
            }
        }
    };

    const handleRemoveCategory = (courseId) => {
        setSelectedCategory(selectedCategory.filter(course => course.id !== courseId));
    };

    const handleRemoveSubCategory = (courseId) => {
        setSelectedSubCategory(selectedSubCategory.filter(course => course.id !== courseId));
    };

    const handleRemoveCourses = (courseId) => {
        setSelectedCourses(selectedCourses.filter(course => course.id !== courseId));
    };
    const handleRemoveBatches = (courseId) => {
        setSelectedBatches(selectedBatches.filter(course => course.id !== courseId));
    };


    const quillReff = useRef(null)
    var details = {}
    function handleRemove(info) {
        let temp = []
        for (let i = 0; i < file.length; i++) {
            if (file[i].uid !== info) {
                temp.push(file[i])
            }
        }
        setfile([...temp]);
        if (hideFile) {
            setFileVisible('old file')
        } else {
            setFileVisible(null);
        }
        // setFileVisible(null)

    }
    const fileSizeLimit = 10 * 1024 * 1024

    const props = {
        name: 'file',
        multiple: true,
        customRequest({ onSuccess }) {
            setTimeout(() => onSuccess('ok'), 0);
        },
        onChange(info) {
            const { status } = info.file;

            if (info.file.status === 'uploading') {
                return

            }

            if (info.file.status === "done" || info.file.status === "error") {
                const fileExtension = info.file.name ? info.file.name.split('.').pop().toLowerCase() : '';
                const isImage = ['png', 'jpg', 'jpeg'].includes(fileExtension);
                const currentLimit = isImage ? 5 * 1024 * 1024 : 10 * 1024 * 1024;
                getBase64(info.file.originFileObj, (imageUrl) => {
                    if (info.file.size > currentLimit) {
                        // setIsFileSize([...file, info.file.originFileObj])
                        Notification.error('Error', isImage ? 'Image size exceeds the limit of 5MB.' : 'File size exceeds the limit of 10MB.');
                        if (hideFile) {
                            setFileVisible('new file and old file')
                        }
                    }
                    else {
                        setfile([...file, info.file.originFileObj])
                        if (hideFile) {
                            setFileVisible('new file and old file')
                        } else {
                            setFileVisible('old file')
                        }

                    }

                });



            }


        },
        onDrop(e) {
            console.log('AAA-Dropped files', e.dataTransfer.files);
        },
        beforeUpload(file) {
            const allowedExtensions = ['doc', 'docx', 'xls', 'xlsx', 'pdf', 'png', 'jpg', 'jpeg'];
            const fileExtension = file.name.split('.').pop().toLowerCase();
            if (!allowedExtensions.includes(fileExtension)) {
                Notification.error('Error', 'Only doc, xlsx, pdf, png, jpg files are supported!');
                return Upload.LIST_IGNORE;
            }
            const isImage = ['png', 'jpg', 'jpeg'].includes(fileExtension);
            if (isImage && file.size > 5 * 1024 * 1024) {
                Notification.error('Error', 'Image size exceeds the limit of 5MB.');
                return Upload.LIST_IGNORE;
            }
            if (!isImage && file.size > 10 * 1024 * 1024) {
                Notification.error('Error', 'File size exceeds the limit of 10MB.');
                return Upload.LIST_IGNORE;
            }
            return true;
        },
        onRemove(info, index) {
            handleRemove(info.uid);
        }
    };
    const getBase64 = (img, callback) => {
        const reader = new FileReader();
        reader.addEventListener("load", () => callback(reader.result));
        reader.readAsDataURL(img);
    };


    const modules = {
        toolbar: [
            [{ 'header': [1, 2, false] }],
            ['bold', 'italic', 'underline'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['link'],
        ],
    }

    const handleCancle = () => {
        setDescriptionLength(null)
        setTarget('All')
        setTitle('')
        setDescription('')
        setDescriptionTyped(false)
        setDate('')
        setTime('')
        setIsModalVisible(false)
    }
    const handleChangeTarget = (value) => {
        if (value) {
            setTarget(value)
        }
        else {
            setTarget('All')
        }
        setStd([])
        setStudentsType('allStudents')
        setSelectedBatches([])
        setSelectedCourses([])
        setSelectedCategory([])
        setSelectedSubCategory([])
        setCheckedItems([])
    }


    useEffect(() => {

        if (edit == '') {
            setDescriptionLength(null)
            setTitle('')
            setDescription('')
            setDescriptionTyped(false)
            setTarget('All')
            setDate(undefined)
            setTime(undefined)
            setfile([])
            setFileVisible(null)
            setCheck(false)
        }

        if (edit == 'schedule') {
            if (editData?.date && editData?.date !== "0000-00-00") {
                setCheck(true)
                setDate(editData?.date)
                setTime(editData?.time && editData?.time !== "00:00:00" ? editData?.time : undefined)
            } else {
                setCheck(false)
                setDate(undefined)
                setTime(undefined)
            }
            setIsDisable(true)
            setTitle(editData?.title)
            setDescription(editData?.description)
            if (editData?.description && editData?.description !== '') {
                setDescriptionTyped(true)
            }
            setfile([])
            setFileVisible(editData?.fileName)
            setTarget(editData?.target ? editData?.target : 'All')
            if (editData?.target == 'Student') {
                if (editData?.subtarget == 'standard') {
                    let standardIds = editData?.standardAnnouncement?.map(item => item?.standardId)

                    setStudentsType('batch')
                    setSelectedBatches(classList.map(({ section, std, ...rest }) => ({
                        ...rest,
                        name: `${std} - ${section}` // Rename 'section' to 'name'
                    })).filter(item => standardIds.includes(item.id)))
                }

                if (editData?.subtarget == 'courses') {
                    setStudentsType('course')
                    const matchedCourses = editData.courseItems
                        .map(item => autocompleteSearchData.find(data =>
                            data.itemId === item.courseId && data.itemType === item.courseType
                        ))
                        .filter(Boolean);
                    setSelectedCourses(matchedCourses)
                }

                if (editData?.subtarget == 'category') {
                    setStudentsType('courseCategory')
                    const matchedCourses = editData.categories
                        .map(item => courseCategoryData.find(data =>
                            data.id === item.id
                        ))
                        .filter(Boolean);
                    setSelectedCategory(matchedCourses)
                }

                if (editData?.subtarget == 'subcategory') {
                    setStudentsType('courseSubcategory')
                    const matchedCourses = editData.subcategories
                        .map(item => courseSubCategoriesData.find(data =>
                            data.id === item.id
                        ))
                        .filter(Boolean);
                    setSelectedSubCategory(matchedCourses)
                }

                if (editData?.subtarget == 'courseType') {
                    setStudentsType('courseType')
                    let courseTypes = []
                    if (editData?.applicableLive) courseTypes.push("course");
                    if (editData?.applicableTest) courseTypes.push("testSeries");
                    if (editData?.applicableStudy) courseTypes.push("studyMaterial");
                    if (editData?.applicableVideo) courseTypes.push("videoResource");
                    setCheckedItems(courseTypes)
                }
            }
            // setDate(moment(editData?.date, 'YYYY-MM-DD').format('YYYY-MM-DD'))
            // setTime(moment(editData?.time, 'HH:mm').format('HH:mm'))
            setId(editData?.id)
            // if (editData?.target == 'Student' && editData?.standardStatus == 0) {
            //     if (editData?.standardAnnouncement?.length != 0) {
            //         editData?.standardAnnouncement?.map((item) => (
            //             std.push(item?.standardId)
            //         ))
            //         setStd(std)
            //         setClassListShow(true)
            //     }
            // }
            // else if (editData?.target == 'Student' && editData?.standardStatus == -1) {
            //     setStd([-1])
            //     setClassListShow(false)
            // }
            // setIsModalVisible(false)

        }
        if (edit == 'draft') {
            setTarget(editData?.target ? editData?.target : 'All')
            if (editData?.target == 'Student') {
                if (editData?.subtarget == 'standard') {
                    let standardIds = editData?.standardAnnouncement?.map(item => item?.standardId)

                    setStudentsType('batch')
                    setSelectedBatches(classList.map(({ section, std, ...rest }) => ({
                        ...rest,
                        name: `${std} - ${section}` // Rename 'section' to 'name'
                    })).filter(item => standardIds.includes(item.id)))
                }

                if (editData?.subtarget == 'courses') {
                    setStudentsType('course')
                    const matchedCourses = editData.courseItems
                        .map(item => autocompleteSearchData.find(data =>
                            data.itemId === item.courseId && data.itemType === item.courseType
                        ))
                        .filter(Boolean);
                    setSelectedCourses(matchedCourses)
                }

                if (editData?.subtarget == 'category') {
                    setStudentsType('courseCategory')
                    const matchedCourses = editData.categories
                        .map(item => courseCategoryData.find(data =>
                            data.id === item.id
                        ))
                        .filter(Boolean);
                    setSelectedCategory(matchedCourses)
                }

                if (editData?.subtarget == 'subcategory') {
                    setStudentsType('courseSubcategory')
                    const matchedCourses = editData.subcategories
                        .map(item => courseSubCategoriesData.find(data =>
                            data.id === item.id
                        ))
                        .filter(Boolean);
                    setSelectedSubCategory(matchedCourses)
                }

                if (editData?.subtarget == 'courseType') {
                    setStudentsType('courseType')
                    let courseTypes = []
                    if (editData?.applicableLive) courseTypes.push("course");
                    if (editData?.applicableTest) courseTypes.push("testSeries");
                    if (editData?.applicableStudy) courseTypes.push("studyMaterial");
                    if (editData?.applicableVideo) courseTypes.push("videoResource");
                    setCheckedItems(courseTypes)
                }
            }
            setTitle(editData?.title)
            setDescription(editData?.description)
            setfile([])
            setFileVisible(editData?.fileName)
            if (editData?.description && editData?.description !== '') {
                setDescriptionTyped(true)
            }
            // setDate(moment(editData?.date, 'YYYY-MM-DD').format('YYYY-MM-DD'))
            // setTime(moment(editData?.time, 'HH:mm').format('HH:mm'))
            setId(editData?.id)
            if (editData?.date && editData?.date !== "0000-00-00") {
                setCheck(true)
                setDate(editData?.date)
                setTime(editData?.time && editData?.time !== "00:00:00" ? editData?.time : undefined)
            } else {
                setCheck(false)
                setDate(undefined)
                setTime(undefined)
            }
            // if (editData?.target == 'Student' && editData?.standardStatus == 0) {
            //     if (editData?.standardAnnouncement?.length != 0) {
            //         let temp = []
            //         editData?.standardAnnouncement?.map((item) => (
            //             temp?.push(item?.standardId)
            //         ))
            //         console.log("AAA-std", std);
            //         setStd(temp)
            //         setClassListShow(true)
            //     }
            // }
            // else if (editData?.target == 'Student' && editData?.standardStatus == -1) {
            //     setStd([-1])
            //     setClassListShow(false)
            // }

        }
    }, [editData])

    useEffect(() => {
        if (isModalVisible && edit !== '' && editData?.typeAnnouncement !== 'file') {
            const timer = setTimeout(() => {
                if (quillReff.current) {
                    if (typeof quillReff.current.focus === 'function') {
                        quillReff.current.focus();
                    } else if (quillReff.current.editor && typeof quillReff.current.editor.focus === 'function') {
                        quillReff.current.editor.focus();
                    }
                }
            }, 300);
            return () => clearTimeout(timer);
        }
    }, [isModalVisible, edit, editData])

    useEffect(() => {
        if (edit === 'schedule' || edit === 'draft') {
            if (editData?.date && editData?.date !== "0000-00-00") {
                setCheck(true)
                setDate(editData?.date)
                if (editData?.time == "00:00:00" || editData?.date == "0000-00-00") {
                    setTime(undefined)
                } else {
                    setTime(editData?.time)
                }
            } else {
                setCheck(false)
                setDate(undefined)
                setTime(undefined)
            }
        } else {
            setCheck(false)
            setDate(undefined)
            setTime(undefined)
        }
    }, [])

    const onChangeCheckBox = (e) => {
        const isChecked = e.target.checked;
        if (!isChecked) {
            setDate(undefined); // Clear the date
            setTime(undefined)
        }
        setCheck(isChecked);
    };

    const handleTitle = (e) => {
        e.preventDefault()
        setTitle(e.target.value)
    }

    const handleDescription = (content, delta, source, editor) => {
        // source == user means while creating or change by user
        if (source == 'user') {
            details = {
                mobile: quillReff.current?.getEditorContents(),
                web: quillReff.current?.editor?.getContents()
            }
            setDescription(JSON.stringify(details))
        }
    }

    const handleDescriptionKeyPress = (event) => {
        if (quillReff.current?.getEditorContents() != '<p><br></p>' && quillReff.current?.editor?.getText().trim() != '') {
            setDescriptionLength(quillReff.current?.editor?.getLength())
            setDescriptionTyped(true)
            details = {
                mobile: quillReff.current?.getEditorContents(),
                web: quillReff.current?.editor?.getContents()
            }
            setDescription(JSON.stringify(details))

        }
        else {
            setDescription('')
            setDescriptionTyped(false)
        }
    }
    const handleDescriptionkeyUp = (e) => {
        if (quillReff.current?.getEditorContents() != '<p><br></p>' && quillReff.current?.editor?.getText().trim() != '') {

            setDescriptionLength(quillReff.current?.editor?.getLength())
            setDescriptionTyped(true)
            details = {
                mobile: quillReff.current?.getEditorContents(),
                web: quillReff.current?.editor?.getContents()
            }
            setDescription(JSON.stringify(details))

        }
        else {
            setDescription('')
            setDescriptionTyped(false)
        }
    }

    const isDisabled = target == 'Student' && !(
        studentsType === 'allStudents' ||
        (studentsType === 'course' && selectedCourses.length > 0) ||
        (studentsType === 'batch' && selectedBatches.length > 0) ||
        (studentsType === 'courseType' && checkedItems.length > 0) ||
        (studentsType === 'courseCategory' && selectedCategory.length > 0) ||
        (studentsType === 'courseSubcategory' && selectedSubCategory.length > 0)
    );

    console.log('isDisabled', isDisabled,
        (((title && title.trim() != '') && description != '' && descriptionLength <= 250 && !isDisabled) || ((title && title.trim() != '') && description != '' && target && descriptionLength <= 250 && !isDisabled) ? announceButtonLoader ? true : false : true));


    const handleButton = (type) => {
        setType(type)
        let object = {}
        if (edit == '') {
            console.log("AA-date1", date);
            if (title && target && type && description !== null) {
                object = {
                    title: title,
                    description: description,
                    target: target,
                    standardIds: std,
                    type: type,
                    date: date ? date : null,
                    time: time ? time : null,
                    typeAnnouncement: "text",
                    // files: [...file],
                }

            } else {
                console.log("AA-date2", date);

                object = {
                    title: title,
                    // description: description,
                    target: target,
                    standardIds: std,
                    type: type,
                    date: date ? date : null,
                    time: time ? time : null,
                    typeAnnouncement: "file",
                    files: [...file],
                }

            }


        }
        if (edit == 'draft') {

            if (title && target && type && description !== null) {

                object = {
                    id: id,
                    title: title,
                    description: description,
                    target: target,
                    standardIds: std,
                    type: type,
                    date: date ? date : null,
                    time: time ? time : null,
                    typeAnnouncement: "text",

                }

            } else {
                object = {
                    id: id,
                    title: title,
                    // description: description,
                    target: target,
                    standardIds: std,
                    type: type,
                    date: date ? date : null,
                    time: time ? time : null,
                    typeAnnouncement: "file",
                    files: [...file],

                }
            }
        }
        if (edit == 'schedule') {

            if (title && target && type && description !== null) {

                object = {
                    id: id,
                    title: title,
                    description: description,
                    target: target,
                    standardIds: std,
                    type: type,
                    date: date ? date : null,
                    time: time ? time : null,
                    typeAnnouncement: "text",

                }

            } else {
                object = {
                    id: id,
                    title: title,
                    // description: description,
                    target: target,
                    standardIds: std,
                    type: type,
                    date: date ? date : null,
                    time: time ? time : null,
                    typeAnnouncement: "file",
                    files: [...file],

                }
            }
        }


        if (object.date && moment(object.date, 'DD/MM/YYYY', true).isValid()) {
            object.date = moment(object.date, 'DD/MM/YYYY').format('YYYY-MM-DD');
        }

        object.courseItems = studentsType == 'course' ? selectedCourses?.map(item => ({
            id: item.itemId,
            resourceType: item.itemType
        })) : [];

        object.standardIds = studentsType == 'batch' ? selectedBatches?.map(item => item.id) : [];
        object.categoryIds = studentsType == 'courseCategory' ? selectedCategory?.map(item => item.id) : [];
        object.subcategoryIds = studentsType == 'courseSubcategory' ? selectedSubCategory?.map(item => item.id) : [];
        object.courseTypes = studentsType == 'courseType' ? checkedItems : [];
        object.subtarget = target == 'Student' ? studentsType == 'course' ? 'courses' : studentsType == 'batch' ? 'standard' : studentsType == 'courseCategory' ? 'category' :
            studentsType == 'courseSubcategory' ? 'subcategory' : studentsType == 'courseType' ? 'courseType' : null : undefined



        if (type == 'ANNOUNCENOW') {
            storeAnnouncePage(1)
            setIsSearch('')
            setAnnounceButtonLoader(true)
            postAnnouncemnt(object, () => setAnnounceButtonLoader(false),
                () => {
                    setAnnounceButtonLoader(false)
                    setAnnounceKey('3')
                    setDraftButtonLoader(false)
                    setScheduleLoader(false)
                    setDeleteButtonLoader(false)
                    setIsModalVisible(false)
                    setTitle('')
                    // setDescription('')
                    setTarget('All')
                    setDate('')
                    setTime('')
                    setStd([])
                    setCheck(false)
                    // notificationBadgeList()
                    togglePageLoader(true)
                    fetchAnnouncement('', '', () => togglePageLoader(false))
                }
            )

        }
        if (type == 'DRAFT') {
            setDraftPage(1)
            // setSort('')
            setIsSearch('')
            setDraftButtonLoader(true)
            postAnnouncemnt(object, () => setDraftButtonLoader(false), () => {
                setAnnounceKey('1')
                setAnnounceButtonLoader(false)
                setDraftButtonLoader(false)
                setScheduleLoader(false)
                setDeleteButtonLoader(false)
                setIsModalVisible(false)
                setTitle('')
                // setDescription('')
                setTarget('All')
                setDate('')
                setTime('')
                setStd([])
                setCheck(false)
                // notificationBadgeList()
                togglePageLoader(true)
                fetchAnnouncement('', '', () => togglePageLoader(false))
            })

        }
        if (type == 'SCHEDULE') {
            // setSort('')
            setSchedulePage(1)
            setIsSearch('')
            setScheduleLoader(true)
            postAnnouncemnt(object, () => setScheduleLoader(false),
                () => {
                    setAnnounceButtonLoader(false)
                    setDraftButtonLoader(false)
                    setAnnounceKey('2')

                    setScheduleLoader(false)
                    setDeleteButtonLoader(false)
                    setIsModalVisible(false)
                    setTitle('')
                    // setDescription('')
                    setTarget('All')
                    setDate('')
                    setTime('')
                    setStd([])
                    setCheck(false)
                    // notificationBadgeList()


                    togglePageLoader(true)
                    fetchAnnouncement('', '', () => togglePageLoader(false))
                })
        }
        setSort([]);
        setStdFilterValue([])

    }

    useEffect(() => {

        if (std[0] != undefined || std[0] != -1) {
            console.log("AAA-std1", std?.length, standardList.length);
            if (std?.length == standardList.length) {
                setClassListShow(false)
                setStd([-1])
            }
        }

    }, [std?.length])
    const handleClass = (e, obj) => {
        if (e.includes(-1)) {
            setClassListShow(false)
            setStd([-1])
            console.log("AA-e1", e, std);

        }
        else if (!e.length == 0) {
            setStd(e)
            console.log("AA-e1", e, std);
        }
        else {
            setStd(e)
            console.log("AA-e2", e, std);

            setClassListShow(true)
        }
    }

    const onSelect = (value, obj) => {
        if (value == -1) {
            setStd([-1])
        }
    }
    const handleDate = (date, dateString) => {
        setMomentDate(false)
        setDate(dateString)
        setIsDisable(true)
    }
    const handleTime = (time, timeString) => {
        setTime(moment(timeString, "hh:mm A").format("HH:mm"));
    }
    const handleDelete = () => {

        setSort('')
        setIsSearch('')
        console.log("AA-id1", id);
        setDeleteButtonLoader(true)
        deleteAnnouncement(id, () => setDeleteButtonLoader(false), () => {
            setAnnounceButtonLoader(false)
            setDraftButtonLoader(false)
            setScheduleLoader(false)
            setDeleteButtonLoader(false)
            setIsModalVisible(false)
            setTitle('')
            // setDescription('')
            setTarget('All')
            setDate('')
            setTime('')
            setStd([])
            setCheck(false)
            // notificationBadgeList()
            setIsModalVisible(false)

            togglePageLoader(true)
            fetchAnnouncement('', '', () => togglePageLoader(false))
        })
        fetchAnnouncement('', '', () => togglePageLoader(false))

    }

    const handleRemoveValue = () => {
        if (file.length != 0) {
            setFileVisible('new file')
        } else {
            setFileVisible(null);
        }
        // setFileVisible(null)
        setHideFile(false)
    }

    const disabledDate = (current) => {
        // Can not select days before today and today
        return current && current < moment().startOf('day');

    }
    const disabledStartTimeHours = () => {
        const hours = [];
        if (date && moment(date, ['DD/MM/YYYY', 'YYYY-MM-DD']).isSame(moment(), 'day')) {
            const minAllowedTime = moment().add(10, 'minutes');
            for (var i = 0; i < minAllowedTime.hour(); i++) {
                hours.push(i);
            }
        }
        return hours;
    };

    const disabledStartTimeMinutes = (selectedHour) => {
        var minutes = [];
        if (date && moment(date, ['DD/MM/YYYY', 'YYYY-MM-DD']).isSame(moment(), 'day')) {
            const minAllowedTime = moment().add(10, 'minutes');
            if (selectedHour === minAllowedTime.hour()) {
                for (var i = 0; i < minAllowedTime.minute(); i++) {
                    minutes.push(i);
                }
            } else if (selectedHour < minAllowedTime.hour()) {
                for (var i = 0; i < 60; i++) {
                    minutes.push(i);
                }
            }
        }
        return minutes;
    }
    // Form changed and mandatory fields validation checks
    const isTitleChanged = (title || '') !== (editData?.title || '');
    const isDescriptionChanged = (description || '') !== (editData?.description || '');
    const isTargetChanged = (target || 'All') !== (editData?.target || 'All');
    
    const initialCheck = !!(editData?.date && editData?.date !== "0000-00-00");
    const isCheckChanged = check !== initialCheck;
    
    const initialDate = (editData?.date && editData?.date !== "0000-00-00") ? editData?.date : undefined;
    const currentDate = (date && date !== "0000-00-00") ? date : undefined;
    const isDateChanged = (currentDate || '') !== (initialDate || '');
    
    const initialTime = (editData?.time && editData?.time !== "00:00:00" && editData?.date !== "0000-00-00") ? editData?.time : undefined;
    const currentTime = (time && time !== "00:00:00" && date !== "0000-00-00") ? time : undefined;
    const isTimeChanged = (currentTime || '') !== (initialTime || '');
    
    // File changes: check if file length is positive or hideFile has changed
    const isFileChanged = file.length > 0 || !hideFile;
    
    // Target types standard/courses/etc. comparisons
    const initialStandardIds = editData?.standardAnnouncement?.map(item => item?.standardId) || [];
    const currentStandardIds = selectedBatches.map(item => item.id);
    const isBatchesChanged = JSON.stringify(initialStandardIds.sort()) !== JSON.stringify(currentStandardIds.sort());
    
    const initialCourses = editData?.courseItems || [];
    const currentCourses = selectedCourses || [];
    const isCoursesChanged = initialCourses.length !== currentCourses.length || currentCourses.some((curr, idx) => {
        const init = initialCourses[idx];
        return !init || init.courseId !== curr.itemId || init.courseType !== curr.itemType;
    });
    
    const initialCategories = editData?.categories?.map(item => item.id) || [];
    const currentCategories = selectedCategory.map(item => item.id);
    const isCategoriesChanged = JSON.stringify(initialCategories.sort()) !== JSON.stringify(currentCategories.sort());
    
    const initialSubcategories = editData?.subcategories?.map(item => item.id) || [];
    const currentSubcategories = selectedSubCategory.map(item => item.id);
    const isSubcategoriesChanged = JSON.stringify(initialSubcategories.sort()) !== JSON.stringify(currentSubcategories.sort());
    
    let initialCourseTypes = [];
    if (editData?.applicableLive) initialCourseTypes.push("course");
    if (editData?.applicableTest) initialCourseTypes.push("testSeries");
    if (editData?.applicableStudy) initialCourseTypes.push("studyMaterial");
    if (editData?.applicableVideo) initialCourseTypes.push("videoResource");
    const isCheckedItemsChanged = JSON.stringify(initialCourseTypes.sort()) !== JSON.stringify(checkedItems.sort());
    
    let initialStudentsType = 'allStudents';
    if (editData?.target === 'Student') {
        if (editData?.subtarget === 'standard') initialStudentsType = 'batch';
        else if (editData?.subtarget === 'courses') initialStudentsType = 'course';
        else if (editData?.subtarget === 'category') initialStudentsType = 'courseCategory';
        else if (editData?.subtarget === 'subcategory') initialStudentsType = 'courseSubcategory';
        else if (editData?.subtarget === 'courseType') initialStudentsType = 'courseType';
    }
    const isStudentsTypeChanged = studentsType !== initialStudentsType;
    
    const isFormChanged = isTitleChanged || isDescriptionChanged || isTargetChanged || isCheckChanged || isDateChanged || isTimeChanged || isFileChanged || isBatchesChanged || isCoursesChanged || isCategoriesChanged || isSubcategoriesChanged || isCheckedItemsChanged || isStudentsTypeChanged;
    
    // Mandatory fields check
    const isTitleFilled = !!(title && title.trim() !== "");
    const isFileFilled = file.length > 0 || hideFile;
    const isDescriptionFilled = !!(description && description.trim() !== "" && (descriptionLength === null || descriptionLength <= 250));
    
    let isTargetValid = true;
    if (target === 'Student') {
        isTargetValid = false;
        if (studentsType === 'batch' && selectedBatches.length > 0) isTargetValid = true;
        else if (studentsType === 'course' && selectedCourses.length > 0) isTargetValid = true;
        else if (studentsType === 'courseCategory' && selectedCategory.length > 0) isTargetValid = true;
        else if (studentsType === 'courseSubcategory' && selectedSubCategory.length > 0) isTargetValid = true;
        else if (studentsType === 'courseType' && checkedItems.length > 0) isTargetValid = true;
    }
    
    const isScheduleValid = !check || (date && time);
    const isMandatoryFieldsFilled = isTitleFilled && (editData?.typeAnnouncement === 'file' ? isFileFilled : isDescriptionFilled) && isTargetValid && isScheduleValid;
    
    const isUpdateDisabled = edit !== '' && (!isFormChanged || !isMandatoryFieldsFilled);

console.log('sssssss',check, date);

    return (
        <div>
            <Drawer
                // className="createFormAnnouncement"
                // className="modal-round-corner"
                visible={isModalVisible}
                width="500px"
                placement="right"
                closable={false}
                onClose={() => handleCancle()}
            >
                <div className='scroll-bar-universal' style={{ height: '90%' }}>
                    <div style={{ padding: '0px 20px', display: 'flex', justifyContent: 'space-between', marginTop: 10 }}>
                        <div style={{ fontWeight: 'bold', fontSize: '20px', color: '#191919', fontFamily: 'Roboto, sans-serif' }}>{edit == '' ? "Create a text announcement" : "Edit Announcement"} </div>
                        <div onClick={() => handleCancle()}><img style={{ height: 16, width: 16, cursor: 'pointer' }} src={Xmark} /></div>
                    </div>
                    <div style={{ padding: '0px 20px' }}>
                        <AnimatedTextField
                            label="Title"
                            isMandatory={true}
                            inputId="title-name"
                            value={title ? title : ''}
                            handleInputChange={(e) => handleTitle(e)}
                        />
                    </div>

                    {
                        editData?.typeAnnouncement === 'file' ?
                            <>
                                <div style={{ marginTop: "20px", padding: '5px 20px' }}>
                                    <div style={{ fontFamily: 'roboto', color: '#AEAEAE' }}>Attachments<span style={{ color: '#ff414d' }}>*</span></div>
                                    <Dragger {...props}
                                        maxCount={1}
                                        disabled={file.length > 0 || (editData?.typeAnnouncement === 'file' && hideFile)}
                                        className={(file.length > 0 || (editData?.typeAnnouncement === 'file' && hideFile)) ? "disabled-drag-box" : ""}
                                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.xsl,.pdf,.doc,.docx,.jpg,.jpeg,.png" listType="picture" progress={PercentageOutlined} style={{ borderColor: "#1089FF" }}>
                                        <div className="ant-upload-drag-icon">
                                            <img src={ic_file_eadd} />
                                        </div>
                                        <div style={{ display: "flex", justifyContent: "center" }}>
                                            <div className="ant-upload-text" style={{ color: "#AEAEAE", fontSize: "13px", fontWeight: "bold" }}>Drop file here or</div>
                                            <div className="ant-upload-hint" style={{ color: "#1089FF", fontSize: "13px", fontWeight: "bold", marginLeft: "5px" }}>
                                                Click to Upload
                                            </div>
                                        </div>
                                        <div style={{ color: '#AEAEAE', fontSize: '11px', marginTop: '6px' }}>
                                            Only (doc, xlsx, pdf, png, jpg, etc.) supported
                                        </div>
                                    </Dragger>
                                </div>


                                {fileVisible == "new file and old file" ? Notification.error("Error", 'Multiple files are not allowed') : null}

                                {hideFile ? <div style={{ marginTop: '10px', width: "100%", padding: '5px 20px' }}>
                                    <div className='shadow-box hover-shadow customCardShadow' style={{ height: "60px", display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0 15px" }}>
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            <img src={file_image_1} style={{ width: "22px", height: "22px", marginRight: "15px" }} />
                                            <div style={{ fontSize: "13px", fontWeight: "bold", color: "#191919" }}>{editData?.fileName[0]?.key}</div>
                                        </div>
                                        <div style={{ cursor: "pointer" }} onClick={() => { handleRemoveValue() }}>
                                            <DeleteOutlined style={{ fontSize: "20px", color: "#FF414D" }} />
                                        </div>

                                    </div>
                                </div> : null}
                            </> :


                            <div className='descriptionClass test-texteditor-wrapper' style={{ padding: '0px 20px', marginTop: 20 }}>
                                <div style={{ display: 'flex' }}>
                                    <div style={{ fontFamily: 'roboto', color: '#AEAEAE' }}>Description</div><span style={{ color: '#ff414d' }}>*</span>
                                </div>

                                <ReactQuill
                                    className='annocnementDescription link-div'
                                    theme='snow'
                                    style={{ height: '100%' }}
                                    modules={modules}
                                    value={description && Object.keys(description).length != 0 ? JSON.parse(description).mobile : ''}
                                    onChange={(content, delta, source, editor) => handleDescription(content, delta, source, editor)}
                                    ref={quillReff}
                                    placeholder="Enter Description"
                                    bounds={'.annocnementDescription'}
                                    //  onBlur={() => handleBlur()}
                                    // onKeyPress={(e) => handleDescriptionKeyPress(e)}
                                    onKeyUp={(e) => handleDescriptionkeyUp(e)}

                                />
                                {descriptionLength != null && descriptionLength > 250 ?
                                    // <Alert type='warning' message='warning' description='Description should be less than 250 character' showIcon/>
                                    <div>
                                        <WarningTwoTone twoToneColor='#FF0000' /> <Text style={{ color: 'red' }}>Description should be less than 250 character</Text>
                                    </div>
                                    : null}
                            </div>
                    }

                    <div style={{ display: 'flex', width: '100%', marginTop: 20, padding: '0px 20px', }}>

                        <div style={{ width: '50%' }}>
                            <div style={{ color: '#aeaeae', fontSize: 14, }}>Target <span style={{ color: '#ff414d' }}>*</span></div>
                            <div style={{ marginLeft: -8, marginTop: -5, }}>
                                <Select
                                    bordered={null}
                                    getPopupContainer={(trigger) => trigger.parentElement}
                                    value={target ? target : null}
                                    onChange={handleChangeTarget}
                                    style={{ width: '98%' }}
                                    suffixIcon={<img src={downArrow} alt="custom icon" style={{ width: 16, height: 16 }} />}
                                >
                                    <Option value={'All'}>All</Option>
                                    <Option value={'Teacher'}>Teacher</Option>
                                    <Option value={'Student'}>Student</Option>
                                    <Option value={'Data Operator'}>Data Operator</Option>
                                    <Option value={'Operation'}>Operations</Option>
                                </Select>
                            </div>
                            <div style={{ borderBottom: '1px solid #d7d7d7', marginLeft: 5, width: '92%', }}></div>
                        </div>
                        {target == 'Student' ?
                            <div style={{ width: '50%', marginLeft: '6%' }}>
                                <div style={{ color: '#aeaeae', fontSize: 14, }}>Select a student group <span style={{ color: '#ff414d' }}>*</span></div>
                                <div style={{ marginLeft: -10, marginTop: -5 }}>
                                    <Select
                                        bordered={null}
                                        // placeholder="Select plan"
                                        getPopupContainer={(trigger) => trigger.parentElement}
                                        value={studentsType}
                                        onChange={(e) => {
                                            setStudentsType(e)
                                        }}
                                        style={{ width: '98%' }}
                                        suffixIcon={<img src={downArrow} alt="custom icon1" style={{ width: 16, height: 16 }} />}
                                    >
                                        <Option value="allStudents">All students</Option>
                                        <Option value="batch">Batch</Option>
                                        <Option value="course">Course</Option>
                                        <Option value="courseType">Course type</Option>
                                        <Option value="courseCategory">Course category</Option>
                                        <Option value="courseSubcategory">Course subcategory</Option>
                                    </Select>
                                </div>
                                <div style={{ borderBottom: '1px solid #d7d7d7', marginLeft: 2, width: '92%', }}></div>
                            </div>
                            : null}
                    </div>

                    {
                        target == 'Student' && studentsType == 'courseType' ?
                            <div style={{ marginLeft: 25, marginTop: 20, width: '90%' }}>
                                <Checkbox.Group value={checkedItems} onChange={handleChange}>
                                    <Row gutter={[20, 10]} style={{ fontFamily: "Roboto, sans-serif" }}>
                                        {options.map((option) => (
                                            <Col key={option.value} xs={24} sm={12} md={12}> {/* 2 items per row */}
                                                <Checkbox
                                                    value={option.value}
                                                    style={{
                                                        color: "#636363",
                                                        fontSize: 16,
                                                        width: 200
                                                    }}
                                                >
                                                    {option.label}
                                                </Checkbox>
                                            </Col>
                                        ))}
                                    </Row>
                                </Checkbox.Group>
                            </div>
                            :
                            target == 'Student' && studentsType == 'courseCategory'
                                ?
                                <div style={{ marginTop: 20 }}>
                                    <div style={{ color: '#aeaeae', fontSize: 14, padding: '0px 20px' }}>Select course categories <span style={{ color: '#ff414d' }}>*</span></div>
                                    <div style={{ marginLeft: 8, marginTop: -5 }}>
                                        <Select
                                            bordered={null}
                                            showSearch={true}
                                            placeholder={
                                                <span style={{ marginLeft: -10, position: 'absolute', zIndex: 1 }}>
                                                    <SearchOutlined style={{ marginRight: 8, color: "#aeaeae" }} />
                                                    Sample: Marketing, Cloud computing etc.
                                                </span>
                                            }

                                            onChange={(value) => {
                                                handleChangeCategories(value);
                                            }}
                                            style={{ width: '98%' }}
                                            suffixIcon={<img src={downArrow} alt="custom icon" style={{ width: 16, height: 16 }} />}
                                            value={null}
                                            filterOption={(input, option) => {
                                                // Case-insensitive search
                                                return option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                            }}
                                            // Optional: customize the no-match message
                                            notFoundContent="No matching category found"
                                        >
                                            {courseCategoryData.map((course) => {
                                                const isSelected = selectedCategory.some(selected => selected.id === course.id);
                                                return (
                                                    <Option
                                                        key={course.id}
                                                        value={course.id}
                                                        style={{
                                                            backgroundColor: isSelected ? '#dacff2' : 'transparent',
                                                            fontWeight: isSelected ? '500' : 'normal',
                                                            borderRadius: 5,

                                                        }}
                                                    >
                                                        {course.name}
                                                    </Option>
                                                );
                                            })}
                                        </Select>
                                    </div>
                                    <div style={{ borderBottom: '1px solid #d7d7d7', marginLeft: 18, width: '92%', }}></div>
                                    <div className="selected-courses">
                                        {selectedCategory.map((course) => (
                                            <div key={course.id} className="course-tag">
                                                {course.name}
                                                <span
                                                    className="remove-icon"
                                                    onClick={() => handleRemoveCategory(course.id)}
                                                >
                                                    <img style={{ width: 12, height: 12, marginTop: -6 }} src={Xmark} />
                                                </span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                :
                                target == 'Student' && studentsType == 'courseSubcategory'
                                    ?
                                    <div style={{ marginTop: 20 }}>
                                        <div style={{ color: '#aeaeae', fontSize: 14, padding: '0px 20px' }}>Select course subcategory <span style={{ color: '#ff414d' }}>*</span></div>
                                        <div style={{ marginLeft: 8, marginTop: -5 }}>
                                            <Select
                                                bordered={null}
                                                showSearch={true}
                                                placeholder={
                                                    <span style={{ marginLeft: -10, position: 'absolute', zIndex: 1 }}>
                                                        <SearchOutlined style={{ marginRight: 8, color: "#aeaeae" }} />
                                                        Sample: Marketing, Cloud computing etc.
                                                    </span>
                                                }

                                                onChange={(value) => {
                                                    console.log("Select changed:", value);
                                                    handleChangeSubCategories(value);
                                                }}
                                                style={{ width: '98%' }}
                                                suffixIcon={<img src={downArrow} alt="custom icon" style={{ width: 16, height: 16 }} />}
                                                value={null}
                                                filterOption={(input, option) => {
                                                    // Case-insensitive search
                                                    return option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                                }}
                                                // Optional: customize the no-match message
                                                notFoundContent="No matching subcategoryy found"
                                            >
                                                {courseSubCategoriesData.map((course) => {
                                                    const isSelected = selectedSubCategory.some(selected => selected.id === course.id);
                                                    return (
                                                        <Option
                                                            key={course.id}
                                                            value={course.id}
                                                            style={{
                                                                backgroundColor: isSelected ? '#dacff2' : 'transparent',
                                                                fontWeight: isSelected ? '500' : 'normal',
                                                                borderRadius: 5,

                                                            }}
                                                        >
                                                            {course.name}
                                                        </Option>
                                                    );
                                                })}
                                            </Select>
                                        </div>
                                        <div style={{ borderBottom: '1px solid #d7d7d7', marginLeft: 18, width: '92%', }}></div>
                                        <div className="selected-courses">
                                            {selectedSubCategory.map((course) => (
                                                <div key={course.id} className="course-tag">
                                                    {course.name}
                                                    <span
                                                        className="remove-icon"
                                                        onClick={() => handleRemoveSubCategory(course.id)}
                                                    >
                                                        <img style={{ width: 12, height: 12, marginTop: -6 }} src={Xmark} />
                                                    </span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    :

                                    target == 'Student' && studentsType == 'course'
                                        ?
                                        <div style={{ marginTop: 20 }}>
                                            <div style={{ color: '#aeaeae', fontSize: 14, padding: '0px 20px' }}>Select course name <span style={{ color: '#ff414d' }}>*</span></div>
                                            <div style={{ marginLeft: 8, marginTop: -5 }}>
                                                <Select
                                                    bordered={null}
                                                    showSearch={true}
                                                    placeholder={
                                                        <span style={{ marginLeft: -10, position: 'absolute', zIndex: 1 }}>
                                                            <SearchOutlined style={{ marginRight: 8, color: "#aeaeae" }} />
                                                            Sample: JEE main 2025 etc.
                                                        </span>
                                                    }

                                                    onChange={(value) => {
                                                        handleChangeCourses(value);
                                                    }}
                                                    style={{ width: '98%' }}
                                                    suffixIcon={<img src={downArrow} alt="custom icon" style={{ width: 16, height: 16 }} />}
                                                    value={null}
                                                    filterOption={(input, option) => {
                                                        // Case-insensitive search
                                                        return option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                                    }}
                                                    // Optional: customize the no-match message
                                                    notFoundContent="No matching course found"
                                                >
                                                    {autocompleteSearchData.map((course) => {
                                                        const isSelected = selectedCourses.some(selected => selected.id === course.id);
                                                        return (
                                                            <Option
                                                                key={course.id}
                                                                value={course.id}
                                                                style={{
                                                                    backgroundColor: isSelected ? '#dacff2' : 'transparent',
                                                                    fontWeight: isSelected ? '500' : 'normal',
                                                                    borderRadius: 5,

                                                                }}
                                                            >
                                                                {course.name}
                                                            </Option>
                                                        );
                                                    })}
                                                </Select>
                                            </div>
                                            <div style={{ borderBottom: '1px solid #d7d7d7', marginLeft: 18, width: '92%', }}></div>
                                            <div className="selected-courses">
                                                {selectedCourses.map((course) => (
                                                    <div key={course.id} className="course-tag">
                                                        {course.name}
                                                        <span
                                                            className="remove-icon"
                                                            onClick={() => handleRemoveCourses(course.id)}
                                                        >
                                                            <img style={{ width: 12, height: 12, marginTop: -6 }} src={Xmark} />
                                                        </span>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        :
                                        target == 'Student' && studentsType == 'batch'
                                            ?
                                            <div style={{ marginTop: 20 }}>
                                                <div style={{ color: '#aeaeae', fontSize: 14, padding: '0px 20px' }}>Select batch <span style={{ color: '#ff414d' }}>*</span></div>
                                                <div style={{ marginLeft: 8, marginTop: -5 }}>
                                                    <Select
                                                        bordered={null}
                                                        showSearch={true}
                                                        placeholder={
                                                            <span style={{ marginLeft: -10, position: 'absolute', zIndex: 1 }}>
                                                                <SearchOutlined style={{ marginRight: 8, color: "#aeaeae" }} />
                                                                Sample: JEE batch 2025 etc.
                                                            </span>
                                                        }

                                                        onChange={(value) => {
                                                            handleChangeBatches(value);
                                                        }}
                                                        style={{ width: '98%' }}
                                                        suffixIcon={<img src={downArrow} alt="custom icon" style={{ width: 16, height: 16 }} />}
                                                        value={null}
                                                        filterOption={(input, option) => {
                                                            // Case-insensitive search
                                                            return option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                                        }}
                                                        // Optional: customize the no-match message
                                                        notFoundContent="No matching batch found"
                                                    >
                                                        {updatedClassList.map((course) => {
                                                            const isSelected = selectedBatches.some(selected => selected.id === course.id);
                                                            return (
                                                                <Option
                                                                    key={course.id}
                                                                    value={course.id}
                                                                    style={{
                                                                        backgroundColor: isSelected ? '#dacff2' : 'transparent',
                                                                        fontWeight: isSelected ? '500' : 'normal',
                                                                        borderRadius: 5,

                                                                    }}
                                                                >
                                                                    {course.name}
                                                                </Option>
                                                            );
                                                        })}
                                                    </Select>
                                                </div>
                                                <div style={{ borderBottom: '1px solid #d7d7d7', marginLeft: 18, width: '92%', }}></div>
                                                <div className="selected-courses">
                                                    {selectedBatches.map((course) => (
                                                        <div key={course.id} className="course-tag">
                                                            {course.name}
                                                            <span
                                                                className="remove-icon"
                                                                onClick={() => handleRemoveBatches(course.id)}
                                                            >
                                                                <img style={{ width: 12, height: 12, marginTop: -6 }} src={Xmark} />
                                                            </span>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                            :
                                            <></>
                    }
                    <div>
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 20, marginLeft: 20 }}>
                            <Checkbox style={{ padding: '5px' }} checked={check} onChange={(e) => { onChangeCheckBox(e) }}>Schedule for Later </Checkbox>
                        </div>

                        {check ?
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginLeft: 25, gap: 70 }}>
                                <div style={{ width: '40%', display: 'flex', flexDirection: 'column' }}>
                                    <AnimatedDatePicker
                                        inputReadOnly={true}
                                        inputId={`${1001}`}
                                        label="Schedule date"
                                        // isMandatory={true}
                                        value={date ? momentDate == '' ? date : moment(date, 'YYYY-MM-DD') : ''}
                                        handleDateChange={handleDate}
                                        // allowClear={true}
                                        disabledDate={disabledDate}
                                    />

                                </div>
                                <div style={{ width: '40%', display: 'flex', flexDirection: 'column' }}>

                                    <AnimatedTimePicker
                                        inputReadOnly={true}
                                        inputId={`start-time-${10001}`}
                                        label="Start time"
                                        // isMandatory={true}
                                        value={time ? moment(time, 'HH:mm') : ''}
                                        handleTimeChange={handleTime}
                                        allowClear={false}
                                        format="hh:mm A"
                                        disabledHours={disabledStartTimeHours}
                                        disabledMinutes={disabledStartTimeMinutes}
                                        disabled={!date}
                                    />

                                </div>
                            </div>
                            : null}
                    </div>
                </div>
                {/* </CreateFormAnnouncementInput> */}
                {/* </CreateFormAnnouncementScroll> */}
                {edit == '' ?
                    <CreateFormAnnouncementButton>
                        <Button loading={draftButtonLoader} type='cancel' style={{ width: '180px', marginRight: "8px", borderRadius: '5px', textAlign: 'center', fontWeight: 'bold' }} onClick={() => handleButton('DRAFT')} disabled={((title && title.trim() != '') && description != '' && descriptionLength <= 250 && !isDisabled && descriptionTyped) || ((title && title.trim() != '') && description != '' && target && descriptionLength <= 250 && !isDisabled && descriptionTyped) ? draftButtonLoader ? true : false : true} >SAVE AS DRAFT</Button>
                        {check !== true ?
                            <Button loading={announceButtonLoader} type='primary' style={{ width: '180px', marginLeft: "8px", borderRadius: '5px', textAlign: 'center', fontWeight: 'bold' }} onClick={() => handleButton('ANNOUNCENOW')} disabled={((title && title.trim() != '') && description != '' && descriptionLength <= 250 && !isDisabled && descriptionTyped) || ((title && title.trim() != '') && description != '' && target && descriptionLength <= 250 && !isDisabled && descriptionTyped) ? announceButtonLoader ? true : false : true}>ANNOUNCE NOW</Button>
                            :
                            <Button loading={scheduleLoader} type='primary' style={{ width: '180px', marginLeft: "8px", borderRadius: '5px', textAlign: 'center', fontWeight: 'bold' }} onClick={() => handleButton('SCHEDULE')}
                                disabled={((title && title.trim() != '' && date && time) && description != '' && descriptionLength <= 250 && !isDisabled) || ((title && title.trim() != '') && description != '' && target && descriptionLength <= 250 && date && time && !isDisabled) ? scheduleLoader ? true : false : true}>SCHEDULE</Button>
                        }
                    </CreateFormAnnouncementButton>
                    :
                    <div style={{ width: '100%' }}>
                        {
                            edit === 'schedule' ?
                                <div>
                                    <EditFormScheduleButton>
                                        <Button style={{ fontWeight: "bold", color: "red", border: "1px solid #d9d9d9", width: '130px', borderRadius: '5px', textAlign: 'center' }} onClick={() => { setDeleteShow(true) }}>DELETE</Button>
                                        {check == true ? (
                                            <>
                                                <Button type='primary' style={{ width: '170px', borderRadius: '5px', textAlign: 'center', fontWeight: 'bold' }} onClick={() => { setCheck(false); setDate(undefined); setTime(undefined) }}
                                                >CANCEL SCHEDULED</Button>
                                                <Button type='primary' style={{ width: '130px', borderRadius: '5px', textAlign: 'center', fontWeight: 'bold' }} onClick={() => handleButton('SCHEDULE')}
                                                    loading={scheduleLoader} disabled={isUpdateDisabled || scheduleLoader || deleteButtonLoader}
                                                >UPDATE</Button>
                                            </>
                                        )
                                            :
                                            (
                                                <>
                                                    <Button loading={draftButtonLoader} type='cancel' style={{ width: '150px', borderRadius: '5px', textAlign: 'center', fontWeight: 'bold' }} onClick={() => handleButton('DRAFT')} disabled={(fileVisible && fileVisible != 'new file and old file' && (title && title.trim() !== '')) || ((title && title.trim() != '' && description != '' && descriptionLength <= 250 && !isDisabled && descriptionTyped) || ((title && title.trim() != '') && description != '' && target && descriptionLength <= 250 && !isDisabled && descriptionTyped)) && (editData?.typeAnnouncement == 'text') ? (draftButtonLoader || deleteButtonLoader) ? true : false : true} >SAVE AS DRAFT</Button>

                                                    <Button loading={announceButtonLoader} type='primary' style={{ width: '150px', borderRadius: '5px', textAlign: 'center', fontWeight: 'bold' }} onClick={() => handleButton('ANNOUNCENOW')} disabled={(fileVisible && fileVisible != 'new file and old file' && (title && title.trim() !== '')) || ((title && title.trim() != '' && description != '' && descriptionLength <= 250 && !isDisabled && descriptionTyped) || ((title && title.trim() != '') && description != '' && target && descriptionLength <= 250 && !isDisabled && descriptionTyped)) && (editData?.typeAnnouncement == 'text') ? (announceButtonLoader || deleteButtonLoader) ? true : false : true}>ANNOUNCE NOW</Button>
                                                </>
                                            )

                                        }


                                    </EditFormScheduleButton>

                                </div>
                                :
                                <EditFormDraftButton>
                                    {(() => {
                                        const isAnnounceDisabled = (fileVisible && fileVisible != 'new file and old file' && (title && title.trim() !== '')) || ((title && title.trim() != '' && description != '' && descriptionLength <= 250 && !isDisabled && descriptionTyped) || ((title && title.trim() != '') && description != '' && target && descriptionLength <= 250 && !isDisabled && descriptionTyped)) && (editData?.typeAnnouncement == 'text') ? (announceButtonLoader || deleteButtonLoader) ? true : false : true;
                                        return (
                                            <>
                                                <Button
                                                    style={{ color: "red", fontWeight: "bold", border: "1px solid #d9d9d9", width: '120px', borderRadius: '5px', textAlign: 'center' }}
                                                    onClick={() => { setDeleteShow(true) }}>DELETE
                                                </Button>
                                                {check !== true ?
                                                    <Button loading={announceButtonLoader} style={{ color: isAnnounceDisabled ? "rgba(0, 0, 0, 0.25)" : "#636363", border: "1px solid #d9d9d9", fontWeight: "bold", width: '150px', borderRadius: '5px', textAlign: 'center' }} onClick={() => handleButton('ANNOUNCENOW')} disabled={isAnnounceDisabled}>ANNOUNCE NOW</Button>
                                                    :
                                                    <Button loading={scheduleLoader} type='primary' style={{ width: '150px', borderRadius: '5px', textAlign: 'center', fontWeight: 'bold' }} onClick={() => handleButton('SCHEDULE')} disabled={!isMandatoryFieldsFilled || scheduleLoader || deleteButtonLoader}>SCHEDULE</Button>
                                                }
                                                <Button loading={draftButtonLoader} type='primary' style={{ width: '150px', borderRadius: '5px', textAlign: 'center', fontWeight: 'bold' }} onClick={() => handleButton('DRAFT', file)}
                                                 disabled={isUpdateDisabled || draftButtonLoader || deleteButtonLoader}
                                                 >UPDATE</Button>
                                            </>
                                        );
                                    })()}
                                </EditFormDraftButton>

                        }
                      

                    </div>

                }

                {/* </CreateFormAnnouncementMain> */}

            </Drawer>

            {deleteShow &&
                <AnnouncementDeleteModal
                    deleteShow={deleteShow}
                    draftButtonLoader={draftButtonLoader}
                    announceButtonLoader={announceButtonLoader}
                    deleteButtonLoader={deleteButtonLoader}
                    onOk={() => handleDelete()}
                    onCancel={() => setDeleteShow(false)}
                />}
        </div>


    )
}


const mapStateToProps = (state) => {
    const {
        standardList,
        sortFilter,
        searchFilter, announcement, storeKey

    } = state.announcement;
    const { courseCategoryData, courseSubCategoriesData, autocompleteSearchData, courseDashboardData } = state.courseManagement
    const { classList } = state.schedule
    return {
        standardList,
        sortFilter, courseCategoryData, courseSubCategoriesData, autocompleteSearchData, classList,
        searchFilter, announcement, storeKey, courseDashboardData,
    };
};

const mapDispatchToProps = (dispatch) => ({
    postAnnouncemnt: (object, callback, successCallback) => dispatch(postAnnouncemnt(object, callback, successCallback)),
    fetchAnnouncement: (search, sort, callback) => dispatch(fetchAnnouncement(search, sort, callback)),
    deleteAnnouncement: (id, callback, successCallback) => dispatch(deleteAnnouncement(id, callback, successCallback)),
    fetchNotification: () => dispatch(fetchNotification()),
    notificationBadgeList: () => dispatch(notificationBadgeList()),
    setAnnounceKey: (val) => dispatch(setAnnounceKey(val)),
    setDraftPage: (res) => dispatch(setDraftPage(res)),
    setSchedulePage: (res) => dispatch(setSchedulePage(res)),
    storeAnnouncePage: (res) => dispatch(storeAnnouncePage(res)),
    getCoursesCategoriesForNotifications: () => dispatch(getCoursesCategoriesForNotifications()),
    getCoursesSubCategoriesForNotification: () => dispatch(getCoursesSubCategoriesForNotification()),
    getAutocompleteSearchForNotification: (search, callBack) => dispatch(getAutocompleteSearchForNotification(search, callBack)),
    fetchClassList: (search, subId, callback) => dispatch(fetchClassList(search, subId, callback)),
    getCourseDashboardData: (callBack) => dispatch(getCourseDashboardData(callBack)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps

)(CreateAnnouncement);